import { configureStore } from '@reduxjs/toolkit';
import authenticationReducer from './authentication/authentication.slice';
import uiSliceReducer from './ui/ui.slice';
import meetReducer from './meeting/meeting.slice';
import mediaReducer from './media/media.slice';
import userListReducer from './user/user.slice';
import studioReducer from './studio/studio.slice';
// import { serializableMiddleware } from './middleware';

export function makeStore() {
  return configureStore({
    reducer: {
      authentication: authenticationReducer,
      ui: uiSliceReducer,
      meeting: meetReducer,
      media: mediaReducer,
      user: userListReducer,
      studio: studioReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [
            'user/setUserList',
            'studio/setBigVideoAndDisplayModeFromUserList',
            'media/setLocalAudioStream',
            'studio/updateBigVideo',
          ],
          // Ignore these field paths in all actions
          // ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
          // Ignore these paths in the state
          ignoredPaths: ['user.userList', 'studio.bigVideoData.rtcStream.stream', 'media.localAudioStream'],
        },
      }),
  });
}

const store = makeStore();

export default store;
